var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Page Not Found")]),_c('b-card',[_c('p',[_vm._v(" Sorry, the page you have requested could not be found. ")]),_c('div',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.buttonClick}},[_vm._v(" Home ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }